import React from "react";
import "./TurnoCard.css";
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, Typography, Button, Chip } from "@mui/material";
import Calendario from '@mui/icons-material/Event';
import Reloj from '@mui/icons-material/AccessTimeRounded';
import Ubicacion from '@mui/icons-material/LocationOnRounded';


const verificarSiTurnoPaso = (fechaString, horaString) => {
  const [dia, mes, anio] = fechaString.split("/");
  const [horas, minutos] = horaString.split(":");
  
  const fechaTurno = new Date(anio, mes - 1, dia, horas, minutos);
  const ahora = new Date();
  
  return fechaTurno < ahora;
};

const TurnoCard = ({ turno, agregarTurno, mostrarAcciones = true, onCancelar, onModificar }) => {
  const theme = useTheme();

  const turnoPasado = verificarSiTurnoPaso(turno.fecha, turno.hora);

  return (
    <Card 
      variant="outlined"
      className="turno-card-mui"
      style={{ '--rojo-theme': theme.palette.primary.main }}
    >
      <CardContent className="turno-card-content">
        

        <div className="turno-card-header">
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            {turno.medico}
          </Typography>

          <Chip 
            label={turno.practica} 
            color="primary" 
            variant="outlined" 
            size="small"
            className="turno-card-chip"
          />
        </div>


        <div className="turno-card-body">
          <div className="info-line">
            <Calendario className="info-icon" />
            <Typography variant="body2" color="text.secondary">
              {turno.fecha}
            </Typography>
          </div>


          <div className="info-line">
            <Reloj className="info-icon" />
            <Typography variant="body2" color="text.secondary">
              {turno.hora}
            </Typography>
          </div>

          <div className="info-line">
            <Ubicacion className="info-icon" />
            <Typography variant="body2" color="text.secondary">
              {turno.sede}
            </Typography>
          </div>
        </div>

        {turno.fechaPropuesta && (
          <div 
            className="info-line propuesta-modificacion" 
            style={{ 
              marginTop: '12px', 
              padding: '10px', 
              backgroundColor: '#fff0f2', 
              borderRadius: '8px',
              border: `1px solid ${theme.palette.primary.main}`
            }}
          >
            <Typography variant="body2" color="primary" fontWeight="bold">
              Propuesta del paciente: {turno.fechaPropuesta} - {turno.horaPropuesta}
            </Typography>
          </div>
        )}
        
        {!turnoPasado && (onCancelar || onModificar) && (
          <div 
            className="turno-card-acciones-wrapper" 
            style={{ 
              marginTop: '16px', 
              display: 'flex', 
              gap: '10px', 
              flexDirection: 'row' 
            }}
          >
            {onCancelar && (
              <Button 
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => onCancelar(turno.id, turno.medico)}
                disableElevation
                style={{ fontWeight: '600', borderRadius: '8px' }}
              >
                Cancelar
              </Button>
            )}

            {onModificar && (
              <Button 
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => onModificar(turno.id)}
                disableElevation
                style={{ fontWeight: '600', borderRadius: '8px' }}
              >
                Modificar
              </Button>
            )}
          </div>
        )}

        {mostrarAcciones && (
          <div className="turno-card-footer">
          <div className="precio-container">

            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color:
                  turno.cobertura === "TOTAL"
                    ? "success.main"
                    : turno.cobertura === "PARCIAL"
                    ? "warning.main"
                    : "text.secondary",
              }}
            >
              Cobertura: {turno.cobertura.replace("_", " ")}
            </Typography>
            
            {turno.costoBase > turno.costo && (
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "line-through",
                  color: "text.secondary",
                }}
              >
                ${turno.costoBase.toLocaleString("es-AR")}
              </Typography>
            )}

            <Typography variant="h5" fontWeight="bold">
              ${turno.costo.toLocaleString("es-AR")}
            </Typography>
          
            {turno.ahorro > 0 && (
              <Typography variant="body2" color="success.main">
                Ahorrás ${turno.ahorro.toLocaleString("es-AR")}
              </Typography>
            )}

          </div>
          
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => agregarTurno(turno)}
            sx={{ mt: 2 }}
          >
            Pre-seleccionar
          </Button>
        </div>
      )}

      </CardContent>
    </Card>
  );
};

export default TurnoCard;